import axios from 'axios'
import { useEffect } from 'react'
import { createContext, useContext, useState } from 'react'
import { API_XANO_BASE_URL } from '../config/api_config'
import { Api_url } from '../common/api_url'
import { courses, skills } from '../utilities/constants'
import { useSelector } from 'react-redux'
import { selectLandingPageDetails, selectUserDetails } from '../redux/otherDetailsSlice'
import { selectAnswers } from '../redux/answersSlice'
import { selectQuestions } from '../redux/mcqSlice'
import { nineNintyNine } from '../pages/AnalysisPage'

const subjectNames = [ "ui & ux", "python", "data analytics", "seo", "sql" ]

const AddonFeatureContext = createContext()

const AddonFeatureProvider = ({ children }) => {

    const landingPage = useSelector(selectLandingPageDetails)
    const userDetails = useSelector(selectUserDetails)
    const answers = useSelector(selectAnswers)
    const questions = useSelector(selectQuestions)

    const email = userDetails?.email
    const skill_name = landingPage?.skill_name
    const userGoal = userDetails?.user_goal
    const rank = userDetails?.user_rank

    const [ courseName, setCourseName ] = useState('')
    const [ usersData, setUsersData ] = useState([])
    const [ rating, setRating ] = useState(0)
    const [ student, setStudent ] = useState(0)
    const [ showPersonaliseAddon, setShowPersonaliseAddon ] = useState(false)
    const [ isModalOpen, setIsModalOpen ] = useState(false)
    const [ showCategoryModal, setShowCategoryModal ] = useState(false)
    const [ skillsToShow, setSkillsToShow ] = useState([])
    const [ showSkillList, setShowSkillList ] = useState(false)
    const [ ratings, setRatings ] = useState([])
    const [ students, setStudents ] = useState([])
    const [ courseNameInModal, setCourseNameInModal ] = useState('')
    const [ imageLink, setImageLink ] = useState('')
    const [ showMentorshipModal, setShowMentorshipModal ] = useState(false)
    const [ categoryName, setCategoryName ] = useState('Programming')
    const [ mentorsList, setMentorsList ] = useState([])
    const [ courseSlug, setCourseSlug ] = useState('programming-courses')
    const [ openModal, setOpenModal ] = useState(false)
    const [ showPurchasedListModal, setShowPurchasedListModal ] = useState(false)
    const [ selectedItems, setSelectedItems ] = useState([])
    const [ courseIndex, setCourseIndex ] = useState(0)
    const [ selectedSkillList, setSelectedSkillList ] = useState([])
    const [ courseList, setCourseList ] = useState([])
    
    const skillIsNotSeo = !subjectNames?.includes(skill_name?.toLowerCase())
    const skillIsJavaOrGoogleAds = skill_name?.toLowerCase() === "java" || skill_name?.toLowerCase() === "google ads"
    const skillIsBusinessManagement = nineNintyNine.includes(skill_name?.toLowerCase())
    
    useEffect(() => {
        const fetchData = async () => {
            try {
                const pageParam = Math.floor(Math.random() * 11)
                const response = await axios.get(
                    API_XANO_BASE_URL + Api_url.GetOurLearnersWorkAt + `?page=${pageParam}`
                )
                setUsersData(response.data.data)
            } catch (error) {
                console.log(error)
            }
        }
        fetchData()
    }, [])
    
    const newLearners = () => {
        const time = new Date()
        const hours = time.getHours()%12
        const minutes = time.getMinutes()
        let maxLearners = hours.toString() + minutes.toString()
        return Math.max(parseInt(maxLearners)+9, 171)
    }

    const calculateScore = () => {
        let score = 0
        const mcq = []
        for (let i = 0; i < 10; i++){
            let object = {
                quiz_id: questions[i]?.q_id,
                user_answer: '',
                is_correct: ''
            }
            if (answers?.[i] !== undefined && answers[i] === questions?.[i]?.answer){
                score += 10
                object.is_correct = 1
            } else {
                object.is_correct = 0
            }
            if (questions?.[i][`option_${answers?.[i]}`]){
                object.user_answer = questions?.[i][`option_${answers?.[i]}`]
            }
            mcq.push(object)
        }
        return { score, mcq }
    }

    const handleSkillSelection = (index) => {
        setCourseNameInModal(courses[index]?.name)
        setImageLink(courses[index]?.image)
        setSkillsToShow(skills[index])
        setRatings(Array.from({ length: skills[index].length }, () => Math.random() < 0.5 ? 4.5 : 5))
        setStudents(Array.from({ length: skills[index]?.length }, () => Math.floor(Math.random() * (1500 - 1300 + 1)) + 1300))
        setShowSkillList(true)
    }
    
    const handleModal = () => setOpenModal(true)

    const value = {
        usersData,
        skillIsNotSeo,
        newLearners,
        calculateScore,
        courseName, 
        setCourseName,
        rating, 
        setRating,
        student,
        setStudent,
        showPersonaliseAddon, 
        setShowPersonaliseAddon,
        skillIsJavaOrGoogleAds,
        isModalOpen,
        setIsModalOpen,
        showCategoryModal, 
        setShowCategoryModal,
        skillsToShow, 
        setSkillsToShow,
        showSkillList, 
        setShowSkillList,
        ratings, 
        setRatings,
        courseNameInModal, 
        setCourseNameInModal,
        students, 
        setStudents,
        imageLink,
        handleSkillSelection,
        showMentorshipModal, 
        setShowMentorshipModal,
        categoryName, 
        setCategoryName,
        mentorsList, 
        setMentorsList,
        courseSlug, 
        setCourseSlug,
        userGoal,
        email,
        openModal, 
        setOpenModal,
        handleModal,
        rank,
        showPurchasedListModal, 
        setShowPurchasedListModal,
        selectedItems, 
        setSelectedItems,
        courseIndex, 
        setCourseIndex,
        skillIsBusinessManagement,
        selectedSkillList, 
        setSelectedSkillList,
        courseList, 
        setCourseList
    }

    return (
        <AddonFeatureContext.Provider value={value}>
            {children}
        </AddonFeatureContext.Provider>
    )
}

export default AddonFeatureProvider

export const useAddonContext = () => useContext(AddonFeatureContext)